import React, {useState} from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import useStyles from '../../assets/styles/DQProV2LoginStyles';
import PoweredByDQ_Default from '../../assets/images/PoweredByDQ_Default.png';
import PoweredByDQ_White from '../../assets/images/PoweredByDQ_white.png';
import { useColorMode } from '../../context/colorMode/colorMode.context';

import { useFormik } from 'formik';
import {changePassword} from "../../services/auth.service";
import {toast} from "../../utils/utils";
import LoaderWithBackDrop from "../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {TOAST_TYPES, USER_ACCESS_LEVEL} from "../../utils/constants";
import {useHistory, useLocation} from "react-router-dom";
import {useAuth} from "../../context/auth";
import { getPostLoginRedirect } from "../Auth/Login/Login.page";
import PasswordWithValidation, { getPasswordChecks } from "../DQPro/DQProV2/components/PasswordWithValidationsField.comp";

function ChangePassword(){
    const { authUser, setAuthUser } = useAuth();
    const classes = useStyles();
    const { isDark } = useColorMode();
    const PoweredByDQ_Logo = isDark ? PoweredByDQ_White : PoweredByDQ_Default;
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ new_password: '', confirm_new_password: '' });
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const returnTo = location.state?.returnTo || (
        authUser?.access_level === USER_ACCESS_LEVEL.INDIVIDUAL_ACCESS_DQ_INSIDER_PORTAL
            ? '/dq_pro/individual-dashboard/score-overview'
            : getPostLoginRedirect(authUser)
    );

    const formik = useFormik({
        initialValues: {
            old_password: '',
            new_password: '',
            confirm_new_password: ''
        },
        onSubmit: async (values) => {

            const newErrors = { new_password: '', confirm_new_password: '' };

            const checks = getPasswordChecks(values.new_password);
            if (!Object.values(checks).every(Boolean)) {
                newErrors.new_password = 'Password must include 8+ chars, upper, lower, number, and special character.';
            } else if (values.new_password === values.old_password) {
                newErrors.new_password = 'New password must be different from your old password.';
            }

            if (values.new_password !== values.confirm_new_password) {
                newErrors.confirm_new_password = "The Confirm Password confirmation doesnt match.";
            }

            setErrors(newErrors);
            if (newErrors.new_password || newErrors.confirm_new_password) return;

            setLoading(true);

            try {
                const result = await changePassword(values.old_password, values.new_password);
                console.log('result.data -> ', result.data);
                if(result.data.updated_password) {
                    setAuthUser({
                        ...authUser,
                        required_password_reset: false
                    });
                    toast(TOAST_TYPES.SUCCESS, "Password Changed", "Successfully Changed Password");
                    history.push(returnTo);

                }
            } catch (e) {
                // already toasted the error
            }

            setLoading(false);
        }
    });


    return (
        <Box className={classes.loginPage} style={{ minHeight: '89vh' }}>
            <Box className={classes.container}>
                <Typography className={classes.welcomeText}>
                    Change Your Password
                </Typography>
                <img
                    src={PoweredByDQ_Logo}
                    alt="Powered by DQ"
                    className={classes.logo}
                    style={{ cursor: 'pointer', marginBottom: 0 }}
                    onClick={() => history.push('/my_workspace')}
                />

                <Box sx={{ width: '100%', mt: 2 }}>
                    <form className={classes.form} onSubmit={formik.handleSubmit}>
                        <Typography className={classes.label}>Current Password</Typography>
                        <Box sx={{ position: 'relative', width: '100%' }}>
                            <input
                                className={classes.input}
                                type={showOldPassword ? 'text' : 'password'}
                                name="old_password"
                                autoComplete="current-password"
                                placeholder="Enter your current password"
                                value={formik.values.old_password}
                                onChange={formik.handleChange}
                                disabled={loading}
                                required
                                style={{ paddingRight: '42px' }}
                            />
                            <IconButton
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => setShowOldPassword((prev) => !prev)}
                                disabled={loading}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: '42%',
                                    transform: 'translateY(-50%)',
                                    borderRadius: '8px',
                                    p: 0.35,
                                    color: 'var(--brand-text-muted, #4d4d4d)',
                                }}
                            >
                                {showOldPassword ? <VisibilityOff style={{ fontSize: 16 }} /> : <Visibility style={{ fontSize: 16 }} />}
                            </IconButton>
                        </Box>

                        <Typography className={classes.label}>New Password</Typography>
                        <PasswordWithValidation
                            value={formik.values.new_password}
                            onChange={(val) => formik.setFieldValue('new_password', val)}
                            placeholder="Create new password"
                            name="new_password"
                            disabled={loading}
                            inputClassName={classes.input}
                        />
                        {errors.new_password && (
                            <Typography style={{ color: '#d32f2f', fontSize: '13px', marginBottom: '10px', marginTop: '-8px', textAlign: 'left', width: '100%', fontWeight: '400' }}>
                                {errors.new_password}
                            </Typography>
                        )}

                        <Typography className={classes.label}>Confirm New Password</Typography>
                        <Box sx={{ position: 'relative', width: '100%' }}>
                            <input
                                className={classes.input}
                                type={showConfirmPassword ? 'text' : 'password'}
                                name="confirm_new_password"
                                autoComplete="new-password"
                                placeholder="Confirm new password"
                                value={formik.values.confirm_new_password}
                                onChange={formik.handleChange}
                                disabled={loading}
                                required
                                style={{ paddingRight: '42px' }}
                            />
                            <IconButton
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => setShowConfirmPassword((prev) => !prev)}
                                disabled={loading}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    borderRadius: '8px',
                                    p: 0.35,
                                    color: 'var(--brand-text-muted, #4d4d4d)',
                                }}
                            >
                                {showConfirmPassword ? <VisibilityOff style={{ fontSize: 16 }} /> : <Visibility style={{ fontSize: 16 }} />}
                            </IconButton>
                        </Box>
                        {errors.confirm_new_password && (
                            <Typography style={{ color: '#d32f2f', fontSize: '13px', marginBottom: '10px', marginTop: '-8px', textAlign: 'left', width: '100%', fontWeight: '400' }}>
                                {errors.confirm_new_password}
                            </Typography>
                        )}

                        <Button
                            className={classes.continueButton}
                            type="submit"
                            disabled={loading}
                            sx={{ mt: 3 }}
                        >
                            {loading ? 'Updating...' : 'Update Password'}
                        </Button>
                    </form>
                </Box>
            </Box>
            <LoaderWithBackDrop loading={loading} />
        </Box>
    );
}

export default ChangePassword;
